import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Action, Store } from '@ngrx/store';
import { IState } from '../shared/models/state';
import { Actions } from '@ngrx/effects';
import { GET_OVERALL_REPORTS_META_DATA_SUCCESS, GetOverallMetaDataAction } from './reports.actions';
import { Observable } from 'rxjs';

@Injectable()
export class OverallMetaDataReportsResolve implements Resolve<Action> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(): Observable<Action> {
    this.store.dispatch(new GetOverallMetaDataAction());
    return this.action$.ofType(GET_OVERALL_REPORTS_META_DATA_SUCCESS).take(1);
  }
}
